import type { AllProductCostsData, GoalSnapshotResponse } from "@repo/shared/types";
import { getWithToken } from "../_client";

// Instance-level (aggregate-across-goals) snapshot reads on the public surface
// (audit §7). The instance comes from the session, so these take only the token.
const BASE = "/public/flow/instance/snapshot";

export function getPublicInstanceExpectedValueSnapshot(token: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/instance-expected-value`, token);
}

export function getPublicInstanceAssetClassForecastSnapshot(token: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/instance-asset-class-forecast`, token);
}

export function getPublicInstanceCostSnapshot(token: string) {
  return getWithToken<GoalSnapshotResponse>(`${BASE}/instance-cost`, token);
}

// Instance-level product costs. Same service (shape) as the advisor's
// `/snapshots/product-costs`; public route is `/public/flow/snapshots/product-costs`.
export function getPublicAllProductCosts(token: string, lang?: string) {
  const params = lang ? `?lang=${lang}` : "";
  return getWithToken<AllProductCostsData>(`/public/flow/snapshots/product-costs${params}`, token);
}
